import { styled } from 'styled-components';
import { NavLink } from 'react-router-dom';
export const StyledNavLink = styled(NavLink)`
  padding: 0;
  margin: 0;
  text-decoration: none;
  color: var(--font-color-dark);
`;
